import {
  FETCH_ESCALATION_POLICIES, FETCH_ESCALATION_POLICIES_SUCCESS, FETCH_ESCALATION_POLICIES_FAIL,
  FETCH_ESCALATION_POLICY, FETCH_ESCALATION_POLICY_SUCCESS, FETCH_ESCALATION_POLICY_FAIL,
  CREATE_ESCALATION_POLICY, CREATE_ESCALATION_POLICY_SUCCESS, CREATE_ESCALATION_POLICY_FAIL,
  UPDATE_ESCALATION_POLICY, UPDATE_ESCALATION_POLICY_SUCCESS, UPDATE_ESCALATION_POLICY_FAIL,
  DELETE_ESCALATION_POLICY, DELETE_ESCALATION_POLICY_SUCCESS, DELETE_ESCALATION_POLICY_FAIL,
  TOGGLE_ESCALATION_POLICY, TOGGLE_ESCALATION_POLICY_SUCCESS, TOGGLE_ESCALATION_POLICY_FAIL,
  FETCH_ESCALATION_EVENTS, FETCH_ESCALATION_EVENTS_SUCCESS, FETCH_ESCALATION_EVENTS_FAIL,
  CLEAR_ESCALATION_MESSAGES,
} from './actionTypes';

// Policies list
export const fetchEscalationPolicies = () => ({ type: FETCH_ESCALATION_POLICIES });
export const fetchEscalationPoliciesSuccess = (policies) => ({ type: FETCH_ESCALATION_POLICIES_SUCCESS, payload: policies });
export const fetchEscalationPoliciesFail = (error) => ({ type: FETCH_ESCALATION_POLICIES_FAIL, payload: error });

// Single policy
export const fetchEscalationPolicy = (id) => ({ type: FETCH_ESCALATION_POLICY, payload: id });
export const fetchEscalationPolicySuccess = (policy) => ({ type: FETCH_ESCALATION_POLICY_SUCCESS, payload: policy });
export const fetchEscalationPolicyFail = (error) => ({ type: FETCH_ESCALATION_POLICY_FAIL, payload: error });

// Create
export const createEscalationPolicy = (data, callback) => ({ type: CREATE_ESCALATION_POLICY, payload: { data, callback } });
export const createEscalationPolicySuccess = (policy) => ({ type: CREATE_ESCALATION_POLICY_SUCCESS, payload: policy });
export const createEscalationPolicyFail = (error) => ({ type: CREATE_ESCALATION_POLICY_FAIL, payload: error });

// Update
export const updateEscalationPolicy = (data, callback) => ({ type: UPDATE_ESCALATION_POLICY, payload: { data, callback } });
export const updateEscalationPolicySuccess = (policy) => ({ type: UPDATE_ESCALATION_POLICY_SUCCESS, payload: policy });
export const updateEscalationPolicyFail = (error) => ({ type: UPDATE_ESCALATION_POLICY_FAIL, payload: error });

// Delete
export const deleteEscalationPolicy = (id, callback) => ({ type: DELETE_ESCALATION_POLICY, payload: { id, callback } });
export const deleteEscalationPolicySuccess = (id) => ({ type: DELETE_ESCALATION_POLICY_SUCCESS, payload: id });
export const deleteEscalationPolicyFail = (error) => ({ type: DELETE_ESCALATION_POLICY_FAIL, payload: error });

// Toggle
export const toggleEscalationPolicy = (id, callback) => ({ type: TOGGLE_ESCALATION_POLICY, payload: { id, callback } });
export const toggleEscalationPolicySuccess = (policy) => ({ type: TOGGLE_ESCALATION_POLICY_SUCCESS, payload: policy });
export const toggleEscalationPolicyFail = (error) => ({ type: TOGGLE_ESCALATION_POLICY_FAIL, payload: error });

// Events
export const fetchEscalationEvents = (page, size, policyId) => ({ type: FETCH_ESCALATION_EVENTS, payload: { page, size, policyId } });
export const fetchEscalationEventsSuccess = (events) => ({ type: FETCH_ESCALATION_EVENTS_SUCCESS, payload: events });
export const fetchEscalationEventsFail = (error) => ({ type: FETCH_ESCALATION_EVENTS_FAIL, payload: error });

// Clear
export const clearEscalationMessages = () => ({ type: CLEAR_ESCALATION_MESSAGES });
